import { NgClass } from "@angular/common";
import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "../button/button.component";

@Component({
    selector: "rask-submit-button",
    templateUrl: "../button/button.component.html",
    styleUrls: ["../button/button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class SubmitButtonComponent extends ButtonComponent implements OnInit {
    ngOnInit(): void {
        super.ngOnInit();
        super.setType("submit");
    }
}
